import { colors, Stack, StackProps } from '@ui-components/neo.tax';

type RightColumnCardProps = StackProps & {
  children: React.ReactNode;
};

export const RightColumnCard = ({ children, ...props }: RightColumnCardProps): React.ReactElement => (
  <Stack paddingX={6} paddingY={6} borderRadius="md" boxShadow="base" backgroundColor={colors.white} gap={8} {...props}>
    {children}
  </Stack>
);
